import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/legal/LegalLayout";

export const Route = createFileRoute("/termini-condizioni")({
  head: () => ({
    meta: [
      { title: "Termini e Condizioni — FlashWeb Agency" },
      { name: "description", content: "Termini e condizioni di utilizzo dei servizi FlashWeb Agency: pacchetti, consegna, pagamenti, responsabilità e assistenza." },
      { property: "og:title", content: "Termini e Condizioni — FlashWeb Agency" },
      { property: "og:description", content: "Condizioni contrattuali dei servizi FlashWeb." },
      { property: "og:url", content: "https://www.flash-web.ch/termini-condizioni" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.flash-web.ch/termini-condizioni" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalLayout title="Termini e Condizioni" updated="7 luglio 2026">
      <h2>1. Oggetto del servizio</h2>
      <p>
        I presenti Termini disciplinano l'utilizzo dei servizi offerti da <strong>FVT FuturaVision
        Technology GmbH</strong> (di seguito "FlashWeb"), tramite il sito{" "}
        <a href="https://www.flash-web.ch">www.flash-web.ch</a>, ai clienti (di seguito "Cliente") che
        richiedano la realizzazione di siti web, applicazioni digitali e servizi correlati.
      </p>

      <h2>2. Descrizione dei pacchetti</h2>
      <p>
        FlashWeb offre pacchetti a tariffa fissa per la realizzazione di siti web professionali (Landing,
        Business, Custom) e servizi accessori (dominio, hosting, manutenzione, marketing). Le
        caratteristiche, i prezzi e le eventuali promozioni sono indicati sul sito e possono essere
        aggiornati in qualsiasi momento.
      </p>

      <h2>3. Tempi di consegna</h2>
      <p>
        FlashWeb si impegna a consegnare il progetto in tempi indicativi di <strong>48 ore</strong> a
        partire dalla ricezione completa dei materiali richiesti al Cliente (testi, immagini, brief,
        accessi). I tempi possono variare per progetti custom, integrazioni complesse o ritardi
        nell'invio dei materiali.
      </p>

      <h2>4. Responsabilità del Cliente</h2>
      <p>Il Cliente si impegna a fornire:</p>
      <ul>
        <li>Testi, immagini, loghi e materiali di sua proprietà o regolarmente licenziati.</li>
        <li>Informazioni corrette e aggiornate per la fatturazione.</li>
        <li>Feedback tempestivi nelle fasi di revisione.</li>
      </ul>
      <p>
        Il Cliente garantisce di detenere tutti i diritti sui contenuti forniti e manleva FlashWeb da
        qualsiasi pretesa di terzi al riguardo.
      </p>

      <h2>5. Revisioni incluse</h2>
      <p>
        Ogni pacchetto include un numero di revisioni indicato in fase di preventivo. Revisioni
        aggiuntive o modifiche strutturali fuori scope saranno quotate separatamente.
      </p>

      <h2>6. Extra e servizi aggiuntivi</h2>
      <p>
        Servizi non compresi nel pacchetto scelto (pagine extra, integrazioni custom, funzionalità
        avanzate, copywriting, produzione foto/video) sono forniti come add-on con quotazione dedicata e
        approvazione preventiva del Cliente.
      </p>

      <h2>7. Pagamenti</h2>
      <ul>
        <li>Il pagamento è richiesto solo dopo l'approvazione formale del preventivo.</li>
        <li>Modalità accettate: bonifico bancario, carta di credito, Stripe, TWINT.</li>
        <li>I prezzi sono espressi in CHF (o valuta indicata), IVA esclusa dove applicabile.</li>
        <li>Il mancato pagamento entro i termini pattuiti autorizza FlashWeb a sospendere il servizio.</li>
      </ul>

      <h2>8. Abbonamenti e manutenzione</h2>
      <p>
        I pacchetti in abbonamento (es. FlashWeb Flex) prevedono un canone ricorrente mensile o annuale.
        Il Cliente può disdire con preavviso di 30 giorni tramite email a{" "}
        <a href="mailto:info@flash-web.ch">info@flash-web.ch</a>. Alla cessazione del contratto, gli
        aggiornamenti e la manutenzione compresi nel piano vengono interrotti.
      </p>

      <h2>9. Limitazioni di responsabilità</h2>
      <p>
        FlashWeb non risponde per danni indiretti, perdita di profitti, dati o opportunità commerciali
        derivanti dall'uso o mancato uso dei servizi. La responsabilità massima di FlashWeb è comunque
        limitata all'importo effettivamente corrisposto dal Cliente nei 12 mesi precedenti l'evento
        contestato.
      </p>

      <h2>10. Proprietà dei contenuti</h2>
      <p>
        A saldo integrale del corrispettivo, il Cliente acquisisce la licenza d'uso perpetua sul sito
        realizzato. Framework, template, librerie open source e componenti riutilizzabili restano di
        proprietà dei rispettivi autori. FlashWeb si riserva il diritto di citare il progetto nel
        proprio portfolio, salvo diverso accordo scritto.
      </p>

      <h2>11. Sospensione o interruzione del servizio</h2>
      <p>
        FlashWeb può sospendere il servizio in caso di violazione dei presenti Termini, mancato
        pagamento, uso illecito del sito o richieste delle autorità competenti. Il Cliente sarà avvisato
        via email con almeno 7 giorni di preavviso, salvo casi di urgenza.
      </p>

      <h2>12. Hosting, dominio e strumenti terzi</h2>
      <p>
        Alcuni servizi (registrazione dominio, hosting, email, gateway di pagamento) sono forniti tramite
        partner terzi (Cloudflare, Hostpoint, Stripe, Supabase e simili) e sono soggetti ai relativi
        termini d'uso. FlashWeb non è responsabile di malfunzionamenti, downtime o modifiche di prezzo
        imputabili a tali fornitori.
      </p>

      <h2>13. Legge applicabile e foro competente</h2>
      <p>
        I presenti Termini sono regolati dalla <strong>legge svizzera</strong>. Per qualsiasi
        controversia sarà competente in via esclusiva il foro di <strong>Zug (CH)</strong>, fatti salvi
        i diritti inderogabili dei consumatori.
      </p>

      <h2>14. Contatti</h2>
      <p>
        Per qualsiasi richiesta relativa ai presenti Termini, scrivi a{" "}
        <a href="mailto:info@flash-web.ch">info@flash-web.ch</a>.
      </p>
    </LegalLayout>
  );
}
